import React from 'react';
import './title.css'

const Header2 = (props) => {
    return ( 
        <article className='article-header'>
            <h1 className='header2'>{props.title}</h1>
            <p className='para-header'>{props.para}</p>
        </article>
     );
}
 
export default Header2;
